<template>
  <v-container id="main" fluid class="pt-0 pb-0">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="7"
        class="pa-0 d-flex justify-center align-center flex-column"
        style="background-color: #8e0d2c; height: 80vh;"
      >
        <h1 class="white--text text-center" style="font-size: 4rem;">Colegio Vizcaya <br> <span style="font-weight: 300;">es tu lugar</span></h1>
        <v-divider width="100px" dark></v-divider>
        <br>
        <h3 class="white--text mb-0 mx-5 text-center">Tus sueños y aspiraciones son grandes, <br>por lo tanto mereces una institución que te respalde e impulse</h3>       
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="5" class="pa-0" v-if="$vuetify.breakpoint.mdAndUp">
        <v-img cover src="/imagenes/objetivo.jpg" height="80vh" width="100%"></v-img>
      </v-col>
    </v-row>
    <v-row style="background-color: #2B2B2B;" v-if="$vuetify.breakpoint.smAndUp">
      <v-col class="py-8" cols="12" sm="4" md="3" offset-md="1">
        <v-row class="mx-0">
          <v-col cols="12" sm="12" md="2">
            <v-icon size="40" color="white"> mdi-web </v-icon>
          </v-col>
          <v-col cols="12" sm="12" md="10">
            <h5 class="font-weight-regular white--text">
              EDUCACIÓN PARA <br>EL MUNDO REAL
            </h5>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="py-8" cols="12" sm="4" md="3" offset-md="1">
        <v-row class="mx-0">
          <v-col cols="12" sm="12" md="2">
            <v-icon size="40" color="white"> mdi-magnify </v-icon>
          </v-col>
          <v-col cols="12" sm="12" md="10">
            <h5 class="font-weight-regular white--text">
              INVESTIGACIÓN <br> PARA RESOLVER
            </h5>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="py-8" cols="12" sm="4" md="3" offset-md="1">
        <v-row class="mx-0">
          <v-col cols="12" sm="12" md="2">
            <v-icon size="40" color="white"> mdi-school </v-icon>
          </v-col>
          <v-col cols="12" sm="12" md="10">
            <h5 class="font-weight-regular white--text">
              VOCACIÓN <br>VIZCAYA
            </h5>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="py-12 bg-image d-flex justify-center align-center" :style="bgPrincipal">
      <v-col cols="12" md="6" lg="6" xl="6" 
      class="d-flex justify-center align-center flex-column">
        <h1 class="white--text font-weight-medium text-center" style="z-index: 2;">
          Conócenos
        </h1>
        <br>
        <h3 v-if="$vuetify.breakpoint.smAndUp" 
        class="white--text text-center" style="z-index: 2;">
          Nuestro objetivo es la formación integral de la persona, en un ambiente de confianza, intercambio personal y colaboración. Dentro del cual cada una se sienta reconocida, valorada, aceptada y estimulada para conquistar su propio desarrollo y adquirir un compromiso de respuesta.
        </h3>
        <router-link :to="link_inicio" style="text-decoration: none; padding-bottom: 10px;">
          <v-btn
            depressed
            rounded
            light
            outlined
            color="white"
            lg
            class="my-4"
            style="z-index: 2;"
          >
            Conócenos
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row class="primary">
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex justify-center align-center flex-column"
      >
        <h1 class="white--text text-center mt-12 mb-4">
          RAPACES
        </h1>
        <router-link :to="rapaces" style="text-decoration: none; padding-bottom: 10px;">
          <v-btn class="mb-12" outlined rounded depressed lg color="white">
            Conoce más
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12" sm="12" md="6" lg="6"
      >
        <FAQ/> 
      </v-col>
      <v-col
         cols="12" sm="12" md="6" lg="6" class="pt-12"
      >
        <ContactFloat
          id="contact" 
          :isMovil="$vuetify.breakpoint.mdAndUp ? false : true " 
          :class="$vuetify.breakpoint.mdAndDown ? '' : 'pb-7'"
        />   
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss" scoped>
.bg-image {
  background-position: center;
  background-size: cover;
  height: 60vh;
  position: relative;
}
.bg-image::after {
  background-color: #122240;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.floating {
  z-index: 6 !important;
  cursor: pointer !important;
  position: fixed !important;
  overflow: hidden !important;
  right: 60px;
  bottom: 20px;
}
</style>
<script>
import { mapState } from "vuex";
import ContactFloat from "@/components/ContactFloat.vue";
import FAQ from "@/components/FAQ.vue";
export default {
  components: {
    ContactFloat,
    FAQ,    
  },
  mounted() {
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    rvoe: null,
    type: '',
    image: "/mdAndDown-2021.jpg",
    url: "",
    carreer: "",
    namecarrer: "",
    logo: "",
    video: "",
    duration: "",
    initial_date: "",
    sliders: [],
    isOnline: false,
    carreerDescription: "",
    options: [],
    modalidad: [],
    location: "",
    constar: "",
    ingreso: [],
    egreso_text: "",
    egreso_list: [],
    btn_link: "",
    the_password: null,
    laboral: null,
    dialogPassword: false,
  }),
  computed: {
    ...mapState({
      link_inicio: (state) => state.cities.link_inicio,
      cities: (state) => state.cities.cities,
      city_options: (state) => state.cities.city_options,
      rapaces: (state) => state.cities.vida[1].route,
    }),
    bgPrincipal() {
      return {
        "background-image": "url('/imagenes/fondo-desenfoque.jpg')",
      };
    },
  },
  methods: {
  },
  watch: {
  },
};
</script>
